import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchLeaveDurationData = createAsyncThunk("fetchLeaveDurationData", async (token) => {

  const getLeaveDuration = CryptoJS.SHA256("/getLeaveDuration" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  const response = await fetch(`${env.backend_api_endpoint}/${getLeaveDuration}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: token,
    },
  });
  
  const resData = await response.json();

  if (resData?.data) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.data = JSON.parse(decrypted); // ✅ replace encrypted data with decrypted JSON
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  // ✅ Return the full response (status, message, and decrypted data)
  return resData;
});

const userDataSlice = createSlice({
  name: "getLeaveDuration",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLeaveDurationData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeaveDurationData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchLeaveDurationData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default userDataSlice.reducer;
